<template>
    <div id="app">
        <router-view v-if="this.isRouterAlive" />
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    computed: {
        ...mapState("settings", ["isRouterAlive"]),
        ...mapState("user", ["userInfo"]),
    },
    mounted() {

    },

    created() {
        // 在页面加载时读取sessionStorage里的状态信息
        // 在页面加载时读取localStorage里的状态信息
        if (localStorage.getItem("userInfo")) {
            this.$store.commit(
                "user/SET_USERINFO",
                JSON.parse(localStorage.getItem("userInfo"))
            );
        }

        // 页面刷新时，将vuex里的信息保存到sessionStorage
        // 在页面刷新时先触发beforeunload事件
        window.addEventListener("beforeunload", () => {
            localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
        });
    },
    methods: {},
};
</script>

<style lang="scss">
#app {
    height: 100vh;
    overflow: hidden;
    .cell{
      // padding: 0!important;
      // height: 35px;
      // line-height: 35px!important;
      // text-align: center;
  }
}
 .cell{
    padding: 0!important;
    height: 30px;
    line-height: 30px!important;
    text-align: center;
    p{
    margin: auto;
    text-align: center;
    }
     .el-tag{
      height:30px !important;
      line-height: 30px!important;
    }
  }
.el-table--mini {
    font-size: 14px !important;
}
.el-table .el-table__cell{
    padding: 10px 0 !important;
}
</style>
